<template>
    <span class="friend-picture">
        <span class="friend-picture__default"
              :style="{'background-image': 'url(/assets/img/default-friend.png)'}"></span>
        <span v-if="src"
              class="friend-picture__image"
              :style="{'background-image': 'url('+ src + ')'}"></span>
    </span>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            default: null,
        },
    },
};
</script>
